export const SIGN_UP_CREATE_COMPANY = "create_company"
export const SIGN_UP_JOIN_COMPANY = "join_company"